export default __webpack_public_path__ + "static/media/swap-horiz.fe747332.svg";